import { Link } from 'react-router-dom'
import { X } from 'lucide-react'
import { PageHeader } from '@/components/layout/page-header'
import { Button } from '@/components/ui/button'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { NewCustomerForm } from '@/app/(dashboard)/customers/_components/NewCustomerForm'
import { apiClient } from '@/lib/api/client'
import { useAsyncData } from '@/src/hooks/useAsyncData'
import { LoadingState } from '@/src/components/LoadingState'
import { ErrorState } from '@/src/components/ErrorState'

export function NewCustomerPage() {
  const { data: profile, error, loading, reload } = useAsyncData(() => apiClient.getProfile(), [])

  if (loading) return <LoadingState label="Checking customer permissions..." />
  if (error) return <ErrorState error={error} onRetry={reload} />

  const canManageCustomers = profile?.is_admin || profile?.role === 'admin'

  return (
    <div className="space-y-6">
      <PageHeader
        title="Add Customer"
        description="Create a customer account for Helm inquiries and consignments."
        breadcrumbs={[{ label: 'Customers', href: '/customers' }, { label: 'Add Customer' }]}
        actions={
          <Button variant="outline" size="sm" className="h-8" asChild>
            <Link to="/customers">
              <X className="h-4 w-4" />
              Cancel
            </Link>
          </Button>
        }
      />

      {canManageCustomers ? (
        <NewCustomerForm />
      ) : (
        <Alert>
          <AlertDescription>Admin access is required to create Helm customers.</AlertDescription>
        </Alert>
      )}
    </div>
  )
}
